import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NotFoundComponent } from './not-found.component';
import {
  FooterComponent
} from './pages/shared/footer/footer.component';
import {
  HeaderComponent
} from './pages/shared/header/header.component';
import {
  SeoService
} from './pages/shared/service/seo.service';
import {
  MovieService
} from './pages/shared/service/movies.service';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    AppComponent,
    NotFoundComponent,
    FooterComponent,
    HeaderComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-app' }),
    AppRoutingModule,
    HttpClientModule,
    FormsModule
  ],
  providers: [
    SeoService,
    MovieService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
